import React from "react";
import { Link } from "react-scroll";
import "../styles/Mission.css";
import ourmission from '../../../Images/our-mission.png'
import HomePageContent from './HomePageContent'


const Mission = () => {
    return (
        <section className="mission" id="mission">
            <div className="mission-container">
                <div className="mission-content">
                    <div className="mission-title"><p>{HomePageContent.our_Mission_Title}</p>
                    </div>
                    <div className="mission-body">{HomePageContent.our_Mission_Content}
                    </div>
                </div>
                <div className="mission-image">
                    <img src={ourmission} alt="mission" />
                </div>

            </div>


        </section>
    )
}

export default Mission;